<template>
  <section class="bg-gray-light">
    <div class="container">
      <div class="row my-3">
        <div class="col">
          <h1>{{ $t("translation.Partenaires") }}</h1>
          <p>
            {{ $t("translation.partenaires_txt") }}
          </p>
          <!--  <p>
            Knight Franck :
          </p>
          <img src="/images/logo-Knight-frank.png" alt="" /> -->
          <p class="mt-4">
            MLG - Monaco Luxury Group :
          </p>
          <img src="/images/logo-mlg.png" alt="" />
          <p class="mt-4">
            Edmiston :
          </p>
          <img src="/images/logo-edmiston.png" alt="" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "account",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
section {
  padding-bottom: 50px;
  padding-top: 40px;
}
</style>
